/**
 * withDeliveryAddresses
 * HOC for wrapping the provided component with DeliveryAddressesProvider
 */

import React from 'react'

import DeliveryAddressesProvider from './delivery-addresses-provider'

export default function withDeliveryAddresses (WrappedComponent) {
  return function DeliveryAddressesProviderHOC(props) {
    return (
      <DeliveryAddressesProvider>
        <WrappedComponent {...props} />
      </DeliveryAddressesProvider>
    )
  }
}
